




















import { Vue, Component, Watch } from 'vue-property-decorator';
import VoteList from '../components/VoteList.vue';

@Component({
  components: {
    VoteList,
  },
})
export default class Home extends Vue {
  active = 0;
  tempValue = '';
  searchWords: string = '';
  type = 1;

  @Watch('tempValue')
  chang() {
    if (!this.tempValue) {
      this.searchWords = '';
    }
  }
  handleClickTab(index: number, id: number) {
    this.tempValue = '';
    this.searchWords = '';
    this.active = index;
    this.type = id;
  }
  handleClickSearch() {
    this.searchWords = this.tempValue;
    // this.searchWords = (this.$refs.input as HTMLInputElement).value;
  }
}
